import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const config = {
  headers: {
    Authorization: localStorage.getItem("access_token"),
    "Content-Type": "application/json",
  },
};

const register = (
  username,
  password,
  role_id,
  company_id,
  email,
  phone,
  lastname,
  name,
  surname,
  settings,
) => {
  return axios.post(
    API_URL + "register",
    {
      username,
      email,
      password,
      role_id,
      company_id,
      phone,
      lastname,
      name,
      surname,
      settings,
    },
    config,
  );
};

const updateUser = (
  id,
  username,
  password,
  role_id,
  company_id,
  email,
  phone,
  lastname,
  name,
  surname,
  settings,
) => {
  return axios.post(
    API_URL + "register",
    {
      id,
      username,
      email,
      password,
      role_id,
      company_id,
      phone,
      lastname,
      name,
      surname,
      settings,
    },
    config,
  );
};

const changePsd = (id, oldpsd, newpsd) => {
  return axios.post(
    API_URL + "changepsd",
    {
      id,
      oldpsd,
      newpsd,
    },
    config,
  );
};

const removeUser = id => {
  return axios.post(
    API_URL + "removeuser",
    {
      id,
    },
    config,
  );
};

const login = (username, password) => {
  return axios
    .post(API_URL + "login", {
      username,
      password,
    })
    .then(response => {
      if (response.data.user) {
        localStorage.setItem("user", JSON.stringify(response.data.user));
        var token = "Bearer " + String(response.data.access_token);
        localStorage.setItem("access_token", token);
      }

      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("access_token");
  return axios.post(API_URL + "signout").then(response => {
    return response.data;
  });
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

const setSettings = async newSettings => {
  // Получаем текущего пользователя
  const currentUser = getCurrentUser();

  // Получаем текущие настройки (если они есть)
  const currentSettings = currentUser?.settings
    ? JSON.parse(currentUser.settings)
    : {};

  // Объединяем настройки (новые перезапишут старые)
  const mergedSettings = {
    ...currentSettings,
    ...newSettings,
  };

  // Отправляем на сервер
  const response = await axios.post(
    `${API_URL}user_settings`,
    { settings: JSON.stringify(mergedSettings) },
    config,
  );

  if (response.status === 200) {
    // Обновляем пользователя в localStorage
    localStorage.setItem("user", JSON.stringify(response.data.user));
  }

  return response.data.msg;
};

const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,
  setSettings,
  updateUser,
  removeUser,
  changePsd,
};

export default AuthService;
